import GraficoBarra from '../../../components/graficoBarra/index';
import GraficoPizza from '../../../components/graficoPizza';
import { ServicesDashboard as useServices } from './services';
import { ContainerCardsExplicativos, ContainerGraficos, ContainerLayout, Grafico } from './style';
import SedeStackComponent from '../../Pg/DashboardPg/stacks/sedes';
import EventosStack from './stack/eventos';
import MembrosStackComponent from '../../Pg/DashboardPg/stacks/membros';
import BatismoStack from './stack/batismo';
import { useEffect } from 'react';

export default function Dash() {

  const {
    getPessoasPorEventoSede,
    pessoasPorCamisaTamanho,
    pessoasPorEstadoCivil,
    pessoasPorGenero,
    pessoasPorIdade,
    pessoasPorSede,
    totalDeEventos,
    todosRegistros,
    pessoasBatizadas,
    alterParams
  } = useServices()

  useEffect(() => {
    pessoasPorSede?.map(sede =>
      getPessoasPorEventoSede(sede?.sede)
    )
  }, [pessoasPorSede])

  return (
    <>
      <ContainerLayout>
        <div/>
        <ContainerCardsExplicativos>
          <EventosStack
            objectWithValues={totalDeEventos}
          />
          <MembrosStackComponent
            objectWithValues={todosRegistros}
          />
          <SedeStackComponent
            objectWithValues={pessoasPorSede}
          />
          <BatismoStack
            objectWithValues={pessoasBatizadas}
          />
        </ContainerCardsExplicativos>
        <ContainerGraficos>
          <Grafico>
            <GraficoBarra
              titulo={"Participantes por Sede"}
              keyForExctratTitles='nomesede'
              keyX='quantidade'
              value='sedes'
              dados={pessoasPorSede}
              color={"#108dff"}
            />
          </Grafico>

          <Grafico>
            <GraficoBarra
              titulo={"Participantes por Idade"}
              keyForExctratTitles='media'
              keyX='quantidade'
              value='Medias'
              dados={pessoasPorIdade}
              color={
                '#12239e'
              }
            />
          </Grafico>
          <Grafico>
            <GraficoPizza
              title={'Participantes Genêros'}
              cores={['#E8C29C', '#99E7FF']}
              descricaoDados='quantidade'
              descricao='genero'
              dados={pessoasPorGenero ?? []}
            />
          </Grafico>
          <Grafico>
            <GraficoPizza
              title={'Participantes Estado Civil'}
              cores={['#716094', '#A487E0', '#E1C09D', '#9DE0A7', '#947759']}
              descricaoDados='quantidade'
              descricao='estadocivil'
              dados={pessoasPorEstadoCivil ?? []}
            />
          </Grafico>



          <Grafico>
            <GraficoBarra
              titulo={`Participantes por Tamanho Camisa`}
              keyForExctratTitles='camisatamanho'
              keyX='quantidade'
              value='Camisas'
              dados={pessoasPorCamisaTamanho}
              color={"#108dff"}
            />
          </Grafico>

        </ContainerGraficos>
      </ContainerLayout>
    </>
  )
}
